import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLabel } from '@platform/hooks/useLabel';
import { Icon } from '@platform/ui';
import { navigationModel, navMode, systemItem } from '@platform/navigation';
import type { IModeToggleButtonProps } from './IModeToggleButtonProps';
import { modeHomePath } from './modeHomePath';
import { useShellNav } from './useShellNav';

/**
 * Кнопка системної частини (UIUX top-bar: Administration · Customization): кругла 34px з іконкою системного пункту моделі навігації.
 * Вмикає відповідний режим навігації (Адміністратор — групи «Головна · Мета», Налаштування рішення — «Головна · Керування ШІ · Мета»)
 * і відкриває його сторінку (Адміністрування чи Налаштування); натиснута (aria-pressed) — повторне натискання повертає типовий режим
 * «Депутат» і Головну.
 */
export function ModeToggleButton({ ws, item, mode }: IModeToggleButtonProps) {
  const { t } = useTranslation();
  const label = useLabel();
  const navigate = useNavigate();
  const nav = useShellNav(ws);
  const system = systemItem(item);
  const on = nav.mode.key === mode;
  const name = mode === 'cust' ? label(navMode(mode).label) : label(system?.label);
  const title = on ? t('shell.modeBack', { mode: label(navMode(navigationModel.defaultMode).label) }) : name;
  const toggle = () => { const next = on ? navigationModel.defaultMode : mode; nav.setMode(next); navigate(modeHomePath(next)); };
  return (
    <button type="button" className="po-topbar__icon tb-icon tb-sys" title={title} aria-label={name} aria-pressed={on} onClick={toggle}>
      <Icon name={system?.icon ?? 'settings'} size={16} />
    </button>
  );
}
